export default __webpack_public_path__ + "static/media/SE70.9d5fb19c.png";